import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-star_pin",
  "use": "icon-star_pin-usage",
  "viewBox": "0 0 10 9",
  "content": "<symbol viewBox=\"0 0 10 9\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-star_pin\">\r\n    <!-- Generator: Sketch 54.1 (76490) - https://sketchapp.com -->\r\n    <title>Star</title>\r\n    <desc>Created with Sketch.</desc>\r\n    <g id=\"icon-star_pin_展示\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\">\r\n        <g id=\"icon-star_pin_icon\" transform=\"translate(-121.000000, -44.000000)\" fill=\"#F5A623\">\r\n            <polygon id=\"icon-star_pin_Star\" points=\"126 51.5 123.061074 53.045085 123.622359 49.7725425 121.244717 47.454915 124.530537 46.9774575 126 44 127.469463 46.9774575 130.755283 47.454915 128.377641 49.7725425 128.938926 53.045085\" />\r\n        </g>\r\n    </g>\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/star_pin.svg
// module id = MlPc
// module chunks = 31